import axios from 'axios';
import { baseApiURL } from '@/constants/config';

const httpClient = axios.create({
  baseURL: baseApiURL,
  timeout: 30000,
});

httpClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      ['authToken', 'name', 'email', 'actor'].forEach((key) => localStorage.removeItem(key));
      window.dispatchEvent(new CustomEvent('clockspotter:session-expired'));
    }
    return Promise.reject(error);
  }
);

export function normalizePath(path) {
  if (!path) return '';
  return path.replace(/^\/Api/, '');
}

export async function apiRequest(method, path, options = {}) {
  const normalizedPath = normalizePath(path);
  const action = normalizedPath.split('/').filter(Boolean).pop() || '';
  const readOnly = /^(Get|Export|Preview)/.test(action);
  if (window.__clockspotterStaleBuild === true && !readOnly) {
    const error = new Error('A newer ClockSpotter release is available. Refresh before saving changes.');
    error.code = 'STALE_CLIENT_RELEASE';
    throw error;
  }
  return httpClient.request({
    method,
    url: normalizedPath,
    params: options.params,
    data: options.data,
    responseType: options.responseType,
    headers: options.headers,
  });
}

export default httpClient;
